import axios from 'axios'

export const AdminICodeColorService = {
  /**
   * @param {*} status blank is for both status(published and inactive)
   * status = 1 ==> for inactive
   * status = 2 ==> for published
   */
  fetchICodeColorList (status = '') {
    if (status !== '') {
      return axios.get(`/api/v1/icodecolorlist/${status}`)
    } else {
      return axios.get('/api/v1/icodecolorlist')
    }
  },
  async fetchPublicICodeColorList (status = '') {
    const feToken = await axios.get(`/getToken`)
    if (status !== '') {
      return axios.get(`/public/api/v1/publicicodecolorlist/${status}`,
        {
          headers: {
            'Authorization': 'Bearer ' + feToken.data.token
          }
        }
      )
    } else {
      return axios.get('/public/api/v1/publicicodecolorlist',
        {
          headers: {
            'Authorization': 'Bearer ' + feToken.data.token
          }
        }
      )
    }
  },
  fetchICodeList (status = '') {
    if (status !== '') {
      return axios.get(`/api/v1/icodelist/${status}`)
    } else {
      return axios.get('/api/v1/icodelist')
    }
  },
  /**
   * edit code year record
   */
  editICodeColorItem (data) {
    return axios.post(`/api/v1/editicodecolor`, JSON.stringify({
      year: data.year,
      icode: data.iCode,
      userId: data.userId,
      id: data.id,
      color: data.color,
      isForLocal: data.isForLocal
    }))
  },
  /**
   * Add new code year record
   */
  addNewICodeColorItem (data) {
    return axios.post(`/api/v1/addicodecolor`, JSON.stringify({
      year: data.year,
      icode: data.iCode,
      userId: data.userId,
      color: data.color,
      isForLocal: data.isForLocal
    }))
  },
  validateICodeColorItem (data) {
    return axios.delete(`/api/v1/deleteicodecolor`, { data: data })
  },
  deleteICodeColorItem (data) {
    return axios.delete(`/api/v1/deleteicodecolor`, { data: data })
  }
}
